var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.shouldRender)?_c('div',{class:_setup.twMerge('py-6 text-center text-sm', _vm.twClass)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }